/**
 * This layout has no navigation, header and footer.
 * This is a plain Screen layout.
 * This layout is used in public "Routes"
 */

import React from "react";
/* Import configuration starts */
/* Import configuration ends */

/* Import redux slices component starts */
/* Import redux slices component ends */

/* Import react bootstrap component starts */
/* Import react bootstrap component ends */

/* Import MUI component starts */
/* Import MUI component ends */

/* Import image and SVG starts */
/* Import image and SVG ends */

/* Import local pages and component starts */
/* Import local pages and component ends */

/* Component starts */
const Layout1 = (props) => {
  /* Props destructuring starts */
  /* Props destructuring ends */

  /* Component states declaration starts */
  /* Component states declaration ends */

  /* Other hooks declaration starts */
  /* Other hooks declaration ends */

  /* Component variable declaration / object destructure starts */
  /* Component variable declaration / object destructure ends */

  /* Component function definition starts */
  /* Component function definition ends */

  /* Component useEffect starts */
  /* Component useEffect ends */

  /* ************* Component rendering. JSX code ************* */
  return (
    <div>
      {props.children}
    </div>
  );
};
/* Component ends */

export default Layout1;
